/* eslint-disable no-param-reassign */
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { OrderRegistrationForListType, OrderRegistrationType } from '../../types';

type OrderRegistrationsStateType = {
    all: OrderRegistrationForListType[],
    fetchingAll: boolean,
    byId: { [id: number]: OrderRegistrationType },
    fetchingById: { [id: number]: boolean }
};

const initialState: OrderRegistrationsStateType = {
    all: [],
    fetchingAll: false,
    byId: {},
    fetchingById: {}
};

const slice = createSlice({
    name: 'orderRegistrations',
    initialState,
    reducers: {
        fetchAll: (state) => {
            state.fetchingAll = true;
        },
        allFetched: (state, action: PayloadAction<{ data: OrderRegistrationForListType[] }>) => {
            state.all = action.payload.data;
            state.fetchingAll = false;
        },
        fetchById: (state, action: PayloadAction<{ id: number }>) => {
            state.fetchingById[action.payload.id] = true;
        },
        byIdFetched: (state, action: PayloadAction<{
            id: number,
            data?: OrderRegistrationType
        }>) => {
            const { id, data } = action.payload;
            state.fetchingById[id] = false;
            if (data) {
                state.byId[id] = data;
            }
        }
    }
});

export default slice;
